/** Shared Lucide icons keep navigation and controls on the same optical grid. */
import {
  Search,
  Eye,
  EyeOff,
  LayoutDashboard,
  WalletCards,
  ArrowLeftRight,
  ChartNoAxesCombined,
  MessageCircle,
  BriefcaseBusiness,
  Settings,
  Users,
  ChartPie,
  ShieldCheck,
  ArrowUpRight as LucideArrowUpRight,
} from 'lucide-react';
export function SearchIcon() {
  return <Search size={18} aria-hidden="true" />;
}
export function EyeIcon({ off }: { off?: boolean }) {
  const Icon = off ? EyeOff : Eye;
  return <Icon size={18} aria-hidden="true" />;
}
export type TabName =
  | 'friends'
  | 'budgets'
  | 'overview'
  | 'accounts'
  | 'transactions'
  | 'analytics'
  | 'advisor'
  | 'investments'
  | 'settings'
  | 'admin';
const icons = {
  friends: Users,
  budgets: ChartPie,
  overview: LayoutDashboard,
  accounts: WalletCards,
  transactions: ArrowLeftRight,
  analytics: ChartNoAxesCombined,
  advisor: MessageCircle,
  investments: BriefcaseBusiness,
  settings: Settings,
  admin: ShieldCheck,
};
export function TabIcon({ name, className }: { name: TabName; className?: string }) {
  const Icon = icons[name];
  return <Icon size={20} className={className} aria-hidden="true" />;
}
export function ArrowUpRight() {
  return <LucideArrowUpRight size={14} aria-hidden="true" />;
}
